import SwitchLang from './src/switch-lang.vue'

export default SwitchLang
